import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Select, Col, Row, Input } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import demandIcon from '../../../assets/images/icons/demand_icon.svg';
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import axios from "axios";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";

const AdvertiserCreate = ({ handlePageViewChange }) => {

    const [status, setStatus] = useState("Active");
    const [statusOptions] = useState([
        { value: 'Active', label: 'Active' },
        { value: 'Suspended', label: 'Suspended' }]);

    const [fullName, setFullName] = useState("");
    const [fullNameIsRequiredError, setFullNameIsRequiredError] = useState(false);

    const [email, setEmail] = useState("");
    const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
    const [emailUrlError, setEmailUrlError] = useState(false);

    const [password, setPassword] = useState("");
    const [passwordIsRequiredError, setPasswordIsRequiredError] = useState(false);
    const [passwordStrengthError, setPasswordStrengthError] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordIsRequiredError, setConfirmPasswordIsRequiredError] =
        useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);


    const [apiKeyValue, setApiKeyValue] = useState({ "GAM": "" });
    const [apiKeyType] = useState("GAM");
    const [apiKeyTypeOptions] = useState([
        { value: 'GAM', label: 'GAM' }]);

    const [buttonProcessing, setButtonProcessing] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    function onChangeStatus(event) {
        setStatus(event)
    }
    function onChangeFullName(event) {
        setFullNameIsRequiredError(false);
        setFullName(event.target.value);
    }

    function onBlurFullName(event) {
        if (event.target.value.trim().length === 0) {
            setFullNameIsRequiredError(true);
        }
        setFullName(event.target.value.trim());
    }

    function onChangeEmail(event) {
        setEmailIsRequiredError(false);
        setEmail(event.target.value.trim());
        if (validateEmail(event.target.value.trim()) === null) {
            setEmailUrlError(true);
        } else {
            setEmailUrlError(false);
        }
    }

    function onBlurEmail(event) {
        if (event.target.value.trim().length === 0) {
            setEmailUrlError(false);
            setEmailIsRequiredError(true);
        }

        setEmail(event.target.value.trim());
    }

    function onChangePassword(event) {

        setPasswordIsRequiredError(false);
        setPassword(event.target.value.trim());

        if (event.target.value.trim().length >= 8) {
            setPasswordStrengthError(false);

            if (confirmPassword !== null) {
                if (event.target.value.trim() !== confirmPassword) {
                    setPasswordMatchError(true);
                } else {
                    setPasswordMatchError(false);
                }
            }
        } else {
            if (event.target.value.trim().length > 0) {
                setPasswordStrengthError(true);
            }

        }
    }

    function onBlurPassword(event) {
        if (event.target.value.trim().length === 0) {
            setPasswordStrengthError(false);
            setPasswordIsRequiredError(true);
        }
    }

    function onChangeConfirmPassword(event) {
        setConfirmPasswordIsRequiredError(false);
        setConfirmPassword(event.target.value.trim());
        if (event.target.value.trim() !== password) {
            setPasswordMatchError(true);
        } else {
            setPasswordMatchError(false);
        }
    }

    function onBlurConfirmpassword(event) {
        if (event.target.value.trim().length === 0) {
            setPasswordMatchError(false);
            setConfirmPasswordIsRequiredError(false);
            setConfirmPasswordIsRequiredError(true);
        }
    }

    function onChangeApiKeyValue(event) {
        let temp = { ...apiKeyValue }
        temp.GAM = event.target.value.trim()
        setApiKeyValue(temp)
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (
            fullName !== "" &&
            email !== "" &&
            password !== "" &&
            confirmPassword !== ""
        ) {
            if (
                fullNameIsRequiredError === false &&
                emailIsRequiredError === false &&
                passwordIsRequiredError === false &&
                confirmPasswordIsRequiredError === false &&
                emailUrlError === false &&
                passwordStrengthError === false &&
                passwordMatchError === false
            ) {
                let payload = {
                    email: email,
                    name: fullName,
                    password: password,
                    status: status,
                    apiKey: apiKeyValue
                };

                setButtonProcessing(true)

                let statusToken = Cookies.get("token_xapads_ssp") ? true : false;
                if (statusToken) {
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `advertiser/createAdv`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                handlePageViewChange("table", "yes")
                            }, 1000)

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }


            }
        } else {

            if (fullName === "") {
                setFullNameIsRequiredError(true);
            }

            if (email === "") {
                setEmailIsRequiredError(true);
            }

            if (password === "") {
                setPasswordIsRequiredError(true);
            }

            if (confirmPassword === "") {
                setConfirmPasswordIsRequiredError(true);
            }
        }
    };


    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
        setVisible(!visible);
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>
                                <img src={demandIcon} alt="USP" /> Advertiser
                            </Link>
                        </li>
                        <li className="primary">Create Advertiser</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                            }}
                        />
                        <h1 className="heading">
                            Create Advertiser
                        </h1>
                    </div>
                </div>
                <div className='container_box--content pt_20'>
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Basic Info</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Name * </label>
                                                <Input className='form_control basic' placeholder='Advertiser Name' autocomplete="off"
                                                    value={fullName}
                                                    onBlur={onBlurFullName}
                                                    onChange={onChangeFullName}
                                                />

                                                <span className="error_content">
                                                    {fullNameIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>

                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Email * </label>
                                                <Input className='form_control basic' placeholder='Email ID' autocomplete="off"
                                                    value={email}
                                                    onBlur={onBlurEmail}
                                                    onChange={onChangeEmail}
                                                />

                                                <span className="error_content">
                                                    {emailIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                    {emailUrlError && (
                                                        <>  Invalid Email Address</>
                                                    )}
                                                </span>
                                            </div>
                                            <div className="form_content_block--group  mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Status * </label>
                                                <Select
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeStatus}
                                                    value={status}
                                                    options={statusOptions}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Password</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container ">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Password * </label>
                                                <div style={{ position: 'relative' }}>
                                                    <Input type={visible ? 'text' : 'password'} className='form_control basic' placeholder='Create Password' autocomplete="off"
                                                        value={password}
                                                        onBlur={onBlurPassword}
                                                        onChange={onChangePassword}
                                                    />
                                                    <span className='hover-password-visibilty-icon '
                                                        onClick={toggleVisibility}
                                                    >
                                                        {visible ?
                                                            <svg

                                                                width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1.66797 9.99999C1.66797 9.99999 4.69827 4.16666 10.0013 4.16666C15.3043 4.16666 18.3346 9.99999 18.3346 9.99999C18.3346 9.99999 15.3043 15.8333 10.0013 15.8333C4.69827 15.8333 1.66797 9.99999 1.66797 9.99999Z" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                            :
                                                            <svg
                                                                width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8.47273 4.18002C8.97333 4.05918 9.48586 3.99877 10 4.00002C15.0909 4.00002 18 10 18 10C17.5585 10.8517 17.032 11.6536 16.4291 12.3925M11.5418 11.59C11.3421 11.8111 11.1012 11.9884 10.8336 12.1113C10.5659 12.2343 10.277 12.3005 9.98407 12.3058C9.69111 12.3111 9.40012 12.2555 9.12844 12.1424C8.85677 12.0292 8.60998 11.8608 8.4028 11.6471C8.19562 11.4335 8.03229 11.179 7.92255 10.8988C7.81282 10.6186 7.75893 10.3185 7.7641 10.0164C7.76927 9.71433 7.83339 9.41639 7.95264 9.1404C8.07189 8.8644 8.24382 8.616 8.45818 8.41001M14.32 14.455C13.0768 15.4323 11.563 15.9736 10 16C4.90909 16 2 10 2 10C2.90465 8.26143 4.15937 6.74247 5.68 5.54502L14.32 14.455Z" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M2 2L18 18" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                    </span>

                                                </div>

                                                <span className="error_content">
                                                    {passwordIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                    {passwordStrengthError && (
                                                        <> Password should be of minimum 8 characters in length</>
                                                    )}
                                                </span>
                                            </div>

                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Confirm Password * </label>
                                                <Input type='password' className='form_control basic' placeholder='Confirm Password' autocomplete="off"
                                                    value={confirmPassword}
                                                    onBlur={onBlurConfirmpassword}
                                                    onChange={onChangeConfirmPassword}
                                                />

                                                <span className="error_content">
                                                    {confirmPasswordIsRequiredError && (
                                                        <>
                                                            <>   This field is required</>
                                                            {passwordMatchError && <br />}
                                                        </>
                                                    )}
                                                    {passwordMatchError && (
                                                        <> Password does not match.</>
                                                    )}
                                                </span>




                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>


                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>API Key</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container mb_0">
                                    <Row gutter={16} className='mt-2'>
                                        <Col span={8}>
                                            <div className="form_content_block--group mb_0">
                                                <div className='input_group input_group_disabled_d2'>
                                                    <Select
                                                        optionFilterProp="label"
                                                        className="form_select basic"
                                                        value={apiKeyType}
                                                        options={apiKeyTypeOptions}
                                                        disabled
                                                    />

                                                </div>
                                                <span className="error_content">
                                                    <></>
                                                </span>

                                            </div>
                                        </Col>
                                        <Col span={16}>
                                            <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                <Input className='form_control basic' placeholder='Enter API Key here' autocomplete="off"
                                                    value={apiKeyValue.GAM}
                                                    onChange={onChangeApiKeyValue}
                                                />

                                                <span className="error_content">
                                                    <></>
                                                </span>

                                            </div>
                                        </Col>

                                    </Row>
                                </div>
                            </Col>

                        </Row>
                    </div>

                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content loader">
                                    <span>Create</span>
                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :

                            <>

                                <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handlePageViewChange("table", "no") }}> Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmit}>Create</button>
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdvertiserCreate
